import { CmsPage } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.TERMS.path,
      name: "Terms",
      key: routesMap.TERMS.path,
      commonRoute: true,
      element: <CmsPage />,
    },
  ];
}
